import { businessInfoEndpointConfiguration } from './businessInfo/businessInfo';
import { queryServicesEndpointConfiguration } from './queryServices/queryServices';
export const endpointConfigurations = [queryServicesEndpointConfiguration, businessInfoEndpointConfiguration];
//# sourceMappingURL=index.js.map